var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentTab === 'custom'),expression:"currentTab === 'custom'"}]},[_c('preview-piece',{attrs:{"background":_vm.setting.backgroundImage,"setting-panel":_vm.settingPanel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }